export default __webpack_public_path__ + "static/media/transfacil_galery_6.1e5c8bfa.jpg";